export enum insProcessPetPlanText {
  T1 = '基本呵護',
  T2 = '完整保護',
  T3 = '全面守護'
};
